<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="item in allDictListData.data['cml_wish_module']"
        :key="item.value"
        :name="item.value"
        :label="item.label"
      >
      <component :is="item.value + '_Page'" :activeName="item.label" :activeValue="item.value" />
    </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { WISH_MODULE } from './static.js'
import IT_Page from './IT_Page.vue';
import MATERIEL_Page from './MATERIEL_Page.vue';
import PROFESSIONAL_SERVICE_Page from './PROFESSIONAL_SERVICE_Page.vue';
import CommonTable from '@/components/CommonTable';

export default {
  name: 'wish-list',
  components: {
    IT_Page,
    MATERIEL_Page,
    PROFESSIONAL_SERVICE_Page,
    CommonTable
  },
  data() {
    return {
      activeName: 'IT'
    };
  },
  computed: {
    ...mapGetters(['allDictListData'])
  },
  mounted() {
    this.tableHead = WISH_MODULE[this.activeName].tableHead;
  },
  methods: {
  },
};
</script>
